/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Users_Settings_Phone_Is_Background_Blurring_Enabled_By_DefaultInputs */

const en_forms_users_settings_phone_is_background_blurring_enabled_by_default = /** @type {(inputs: Forms_Users_Settings_Phone_Is_Background_Blurring_Enabled_By_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default`)
};

const de_forms_users_settings_phone_is_background_blurring_enabled_by_default = /** @type {(inputs: Forms_Users_Settings_Phone_Is_Background_Blurring_Enabled_By_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hintergrundunschärfe standardmäßig aktiviert`)
};

/**
* | output |
* | --- |
* | "Default" |
*
* @param {Forms_Users_Settings_Phone_Is_Background_Blurring_Enabled_By_DefaultInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_users_settings_phone_is_background_blurring_enabled_by_default = /** @type {((inputs?: Forms_Users_Settings_Phone_Is_Background_Blurring_Enabled_By_DefaultInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Users_Settings_Phone_Is_Background_Blurring_Enabled_By_DefaultInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_users_settings_phone_is_background_blurring_enabled_by_default(inputs)
	return de_forms_users_settings_phone_is_background_blurring_enabled_by_default(inputs)
});